import * as React from 'react';
import 'moment/locale/ar';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import useStore, { updateScreenWidth } from '../Store/Store.js';
import moment from 'moment';
import ProfileDropDown from './components/ProfileDropDown.jsx';
import LanguageSelector from '../components/LanguageSelector';
import NotificationDropDown from './components/NotificationDropDown.jsx';
import IconButton from '../components/IconButton.jsx';
import { ICON_BUTTON_TYPE } from '../constants/index.js';
import SideBar from '../components/SideBar.jsx';
import { useTranslation } from 'react-i18next';
const NewUserInfo = ({ height = '100vh', isSideBar = true }) => {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const features = useStore((state) => state.features);
  const [sidebar, setSidebar] = React.useState(false);
  const { t, i18n } = useTranslation();
  moment.locale(i18n.language);
  // Navigation handler for sidebar
  const handleClickNav = (path) => {
    setSidebar(false);
    history(path);
  };

  // Responsive width update
  React.useEffect(() => {
    const updateDimensions = () => {
      updateScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <>
      {isSideBar && width > 850 && <SideBar height={height} onNavigate={handleClickNav} />}
      <div>
        <div
          style={{
            display: width > 850 ? 'flex' : 'block',
            flexDirection: width > 850 ? 'row' : 'column',
            justifyContent: width > 850 ? 'flex-end' : 'space-between',
            alignItems: 'center',
            marginTop: '10px',
            width: '99%',
          }}
        >
          {/*
          <div style={{ display: 'flex', alignItems: 'center', border: '1px solid blue' }}>
            {width < 850 && (
              <IconButton
                type={ICON_BUTTON_TYPE.menu}
                style={{ marginRight: '15px' }}
                onClick={() => setSidebar(true)}
              />
            )}
            <div> {features.searchbar && <SearchBox />}</div>
          </div>
          */}
          <div style={{ display: 'flex', alignItems: 'center', marginTop: width > 850 ? '0' : '20px' }}>
            {width > 550 && (
              <span style={{ color: '#93939c', marginRight: '10px' }}>
                {t('today')} {moment().format('ddd, DD, MMM, YYYY')}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: width > 850 ? '0' : '20px' }}>
            <LanguageSelector variant="dropdown" style={{ marginRight: '12px' }} />
            {features.notification && <NotificationDropDown userId={user?._id} />}
          </div>
          <div style={{ display: 'flex', marginTop: width > 850 ? '0' : '20px' }}>
            <ProfileDropDown user={user} />
          </div>
        </div>
      </div>
      {/* Mobile sidebar as dialog */}
      {isSideBar && width <= 850 && (
        <SideBar
          height={height}
          isMobile={true}
          open={sidebar}
          onClose={() => setSidebar(false)}
          onNavigate={handleClickNav}
        />
      )}
      {/* Mobile menu button */}
      {isSideBar && width <= 850 && (
        <IconButton
          type={ICON_BUTTON_TYPE.menu}
          style={{ position: 'fixed', top: 20, left: 20, zIndex: 2000 }}
          onClick={() => setSidebar(true)}
        />
      )}
    </>
  );
};

export default NewUserInfo;
